<template>
  <div class="config_box">
    <el-container class="header_container">
      <el-header height="40px">
        <h2>广告配置-广点通</h2>
      </el-header>
      <el-main>
        <!-- 已有配置框 -->
        <div class="have_config">
          <div class="config_title">已有配置列表</div>
          <div v-for="item in medias" :key="item.type" class="have_config_box">
            <p>{{ item.type }}</p>
            <template v-if="config_list[item.value]">
              <div
                v-for="advertiser_item in config_list[item.value]"
                :key="advertiser_item.id"
                class="item"
              >
                <el-tooltip :open-delay="500" effect="dark" :content="advertiser_item.label" placement="top">
                  <span> {{ advertiser_item.id }} - {{ advertiser_item.label }}({{ advertiser_item.note }})</span>
                </el-tooltip>
              </div>
            </template>
          </div>
        </div>
        <div class="config_form">
          <div class="config_title">配置表单</div>
          <el-form
            ref="ruleForm"
            :v-loading="add_config.loading"
            :model="add_config.params.params"
            :rules="rules"
            label-width="100px"
            class="config_form_content"
          >
            <!-- 配置 -->
            <el-form-item
              v-for="form_item in medias"
              :key="form_item.type"
              :label="form_item.type"
              :prop="form_item.value"
            >
              <el-select
                v-model="add_config.params.params[form_item.value]"
                placeholder="请选择"
                multiple
                filterable
                value-key="label"
              >
                <el-option
                  v-for="item in form_item.options"
                  :key="item.id"
                  :label="item.label"
                  :value="item"
                />
              </el-select>
              <br><br>
            </el-form-item>
            <div class="floor-button">
              <el-button size="mini" @click="resetForm()">重置</el-button>
              <el-button size="mini" type="primary" @click="submitForm">保存</el-button>
            </div>
          </el-form>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import ConfigResource from '@/api/config';
const configResource = new ConfigResource();

import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();
export default {
  components: {
    'tree-shuttle': () => import('@/components/tree-shuttle'),
  },
  data() {
    return {
      medias: [
        {
          type: '广点通',
          value: 'gdt_pack_account',
          options: [],
        },
        {
          type: '今日头条',
          value: 'jrtt_pack_account',
          options: [],
        },
      ],
      config_list: [],
      rules: {
        gdt_pack_account: [
          { type: 'array', required: true, message: '请至少选择一个广点通广告主', trigger: 'change' },
        ],
        jrtt_pack_account: [
          { type: 'array', required: true, message: '请至少选择一个今日头条广告主', trigger: 'change' },
        ],
      },
      // 添加配置
      add_config: {
        loading: false,
        params: {
          module: 'ad',
          params: {
            gdt_pack_account: [],
            jrtt_pack_account: [],
          },
        },
      },
      // 获取广告主
      advertiser: {
        loading: true,
        params: {
          is_list: true,
          allot: 1,
        },
      },
    };
  },
  created(){
    this.getConfigList();
    this.getGdtMediasList();
    this.getJrttMediasList();
  },

  methods: {
    // 获取广告配置列表
    getConfigList: function() {
      return new Promise((resolve, reject) => {
        configResource
          .getConfigListApi({ module: 'ad' })
          .then((response) => {
            this.config_list = response.list;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取广点通广告主
    getGdtMediasList() {
      this.advertiser.loading = true;
      mediasResource
        .getMediasListApi({ type: 'gdt', ...this.advertiser.params })
        .then(response => {
          this.setMediasList('gdt_pack_account', response);
          this.advertiser.loading = false;
        })
        .catch(() => {
          this.advertiser.loading = false;
        });
    },

    // 获取头条广告主
    getJrttMediasList() {
      this.advertiser.loading = true;
      mediasResource
        .getMediasListApi({ type: 'jrtt', ...this.advertiser.params })
        .then(response => {
          this.setMediasList('jrtt_pack_account', response);
          this.advertiser.loading = false;
        })
        .catch(() => {
          this.advertiser.loading = false;
        });
    },

    /**
     * 格式化获取的媒体数据
     * @param type 当前广告主类型
     * @param data 广告主列表
    */
    setMediasList(type, data){
      const list = data.list.map(item => {
        return {
          id: item.advertiser_id,
          label: item.advertiser_name,
          note: item.note,
        };
      });
      this.medias.find(item => {
        return item.value === type;
      }).options = list;
      this.add_config.params.params[type] = this.config_list[type];
    },

    // 重置表单
    resetForm() {
      this.$refs['ruleForm'].resetFields();
    },

    // 保存
    submitForm(){
      this.add_config.loading = true;
      configResource
        .setConfigApi(this.add_config.params)
        .then(response => {
          this.$message.success(response.message);
          this.add_config.loading = false;
          this.getConfigList();
        })
        .catch(() => {
          this.add_config.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.config_box{
  padding: 10px;
 .header_container {
  background: #eef0f3;
  border-radius: 5px;
  .el-header {
    border-bottom: 1px solid #fff;
    h2 {
      margin: 0;
      height: 40px;
      line-height: 40px;
    }
  }
  .el-main{
    .have_config{
      width: 300px;
      height: 450px;
      background: #fff;
      float: left;
      padding: 20px;
      .have_config_box{
        width: 240px;
        height: 190px;
        overflow: hidden auto;
        p{
          font-size: 13px;
        }
        .item{
          margin-bottom: 10px;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          cursor: pointer;
        }
      }
    }
    .config_form{
      width: 700px;
      height: 450px;
      background: #fff;
      float: left;
      padding: 20px;
      margin-left: 20px;
      position: relative;
      .config_form_content{
        padding: 20px;
        .el-select{
          width: 350px;
        }
      }
    }
  }
 }
}

.floor-button{
  width: 500px;
  position: absolute;
  bottom: 50px;
  text-align: center;
}
.config_title{
  text-align: center;
  font-size: 15px;
  font-weight: 700;
}
</style>
